module.exports = __webpack_public_path__ + "static/media/img.password.d96a7210.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/UserCenter/img/img.password.svg
// module id = 4399
// module chunks = 0